import Image from '../../images/bio.png'

const Bio = () => {
  return (
    <section className="bio">
      <div className="container bio__container">
        <div className="bio__left">
          <div className="bio__circle"></div>
          <div className="bio__image">
            <img src={Image} alt="Celebrant Headshot" />
          </div>
        </div>
        <div className="bio__right">
          <h4>#celebratewithgabi</h4>
          <h2>Hi, I'm Gabi, Let Me Bring Some Magick To Your Next Celebration!</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi ut veniam aliquid illo ipsam repellendus itaque facere. Voluptatem ab, quis quas eligendi quaerat non labore.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Bio

// import Bio from '../../components/sections/Bio'